import React from "react"

import Board_Manager from "../../../../../../gd-modules/tasks-view/board/managers/manager"
import FieldProto from "../../../../../proto/field-proto"
import Board_AggregateShell from "../../../../../../gd-modules/tasks-view/board/components/aggregate/aggregate-shell"
import formatDate from "../../../../../../gd/format/date"

type Props = {
    className       : string

    manager         : Board_Manager
    field           : FieldProto

    calculatedData  : {
        own             : {
            moment      : Moment,
            momentRange : MomentRange
        }
        children        : {
            moment      : Moment,
            momentRange : MomentRange
        }
        total           : {
            moment      : Moment,
            momentRange : MomentRange
        }

        hasOwnValue     : boolean
        hasChildren     : boolean
    }
}

// const debug = "FieldDate_BoardAggregate"
const debug = false

export default function FieldDate_BoardAggregate(props: Props) {

    const value = props.calculatedData?.total.moment || props.calculatedData?.total.momentRange
    const isValid = !_.isNil(value) && !_.isNaN(value)

    debug && console.log(debug, 'render', isValid, value, props.calculatedData)

    let valueLabel
    if (isValid) {
        if ((value as any).start) {
            const range: any = value
            valueLabel = '{0} - {1}'.f(formatDate(range.start), formatDate(range.end))
        } else {
            valueLabel = formatDate(value as Moment)
        }
    }

    const classes = Classes("left-aligned flex-no-shrink max-w-130", props.className, {
        'show-on-hover': !isValid
    })

    return (
        <Board_AggregateShell
            className   = {classes}
            manager     = {props.manager}
            hint        = {valueLabel}
        >
            <div className="flex-row-left-center txt-truncate">
                <div className={Classes("ui5-ico-12 m-r-5 m-t-1", props.field.icon)}/>
                <div className="ui5-txt-not-important-small txt-truncate">
                    {valueLabel}
                </div>
            </div>
        </Board_AggregateShell>
    )
}
